export default "__VITE_ASSET__CwXECWi7__"